module.exports = __webpack_public_path__ + "static/media/ring.a74b0efd.svg";